// extracted by mini-css-extract-plugin
export default {"publicPageImage":"PublicPage_publicPageImage__25pNB","logoPublicPage":"PublicPage_logoPublicPage__QRf9W","formContainer":"PublicPage_formContainer__3Nd6B"};